module.exports = __webpack_public_path__ + "static/media/country_gq.dc5a4d66.webp";